import { z } from "zod";

/**
 * Element-type price keys (column headers in the JSON map). The set differs per
 * region: `profil_indi_options_prices` stores EU (region 1) and US (region 2)
 * rows with different element_type vocabularies, so each page passes the list
 * it renders. Currency is never taken from here — it travels with the region
 * (§D.14).
 */
export const PROFIL_INDIE_ELEMENT_TYPES = [
  "RND", "RSN", "RSF", "RSU", "RSK", "REN",
  "NMR", "SMA", "SBF", "SBF-K", "EBF", "NBR",
] as const;

/** US (region 2) element types — sourced from the live region-2 price rows. */
export const PROFIL_INDIE_ELEMENT_TYPES_US = [
  "RND", "RSN", "SBF", "EBF", "NBR", "CP",
  "CS", "HS", "UP", "A9N", "HIP", "MHD",
  "MHN", "PFS", "SES", "UMP",
] as const;

export type ProfilIndieElementType = (typeof PROFIL_INDIE_ELEMENT_TYPES)[number];

export const profilIndieOptionSchema = z.object({
  optionName: z.string().min(1, "Option name is required"),
  subCategory: z.string().min(1, "Sub-category is required"),
  // Keys stay open (string) because the rendered element-type list is
  // region-specific; the page only ever registers inputs for its own list.
  prices: z.record(
    z.string(),
    z.coerce.number({ invalid_type_error: "Must be a number" }).nonnegative("Must be ≥ 0"),
  ),
});

export type ProfilIndieOptionFormData = z.infer<typeof profilIndieOptionSchema>;
